import React, { useEffect, useState, useRef } from 'react';

import { TabView, TabPanel } from 'primereact/tabview';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { Checkbox } from 'primereact/checkbox';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Divider } from 'primereact/divider';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Fieldset } from 'primereact/fieldset';
import moment from 'moment-timezone';

import functions from 'lib/functions';
import fetchApi from 'lib/fetchApi';

import Asterisk from 'components/Asterisk';
import EducationProfileBoxEdit from 'components/EducationProfileBoxEdit';
import WorkExperienceProfileBoxEdit from 'components/WorkExperienceProfileBoxEdit';

const JOB_TYPES = require('jsons/job_types.json');
const MARITALS = require('jsons/maritals.json');
const NATIONALITIES = require('jsons/nationalities.json');
const RELIGIONS = require('jsons/religions.json');
const EDUCATIONS = require('jsons/educations.json');
const WORK_TYPES = require('jsons/work_types.json');
const WORK_LOCATIONS = require('jsons/work_locations.json');
const CONTRACT_STATUSES = require('jsons/contract_statuses.json');
const CHINESE_ZODIACS = require('jsons/chinese_zodiacs.json');
const DAYOFFS = require('jsons/dayoffs.json');
const LIVINGS = require('jsons/livings.json');
const SKILLS = require('jsons/skills.json');
const COOKING_SKILLS = require('jsons/cooking_skills.json');
const LANGUAGES = require('jsons/languages.json');
const CURRENCIES = require('jsons/currencies.json');
const PERSONALITIES = require('jsons/personalities.json');

const HelperUpdate = (props) => {
  const toast = useRef(null);
  const [detail, setDetail] = useState(null);
  const [profile, setProfile] = useState(null);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    props.setPageParams({
      alias: 'helperupdate',
      title: '外傭檔案編輯工具'
    });
    getProfile();
  }, []);

  const getProfile = async () => {
    const response = await fetchApi('user/list', {
      user_type_id: 2,
      user_id: functions.getUrlAttr('helper_profile_id')
    });
    if (response.data.users.length > 0) {
      setDetail(response.data.users[0]);
      setProfile(response.data.users[0].functional_profile);
    }
  };

  const updateProfile = (field, value) => {
    setProfile({
      ...profile,
      [field]: value
    });
  };

  const updateProfileCheckbox = (field, checked, value) => {
    const old_value = profile[field];
    var new_value = [];
    if (checked) {
      new_value = [
        ...old_value,
        value
      ];
    } else {
      new_value = old_value.filter(item => item !== value);
    }
    updateProfile(field, new_value);
  };

  const getRandomData = async (field) => {
    try {
      const response = await fetchApi('https://randomuser.me/api/');
      console.log(response);
    } catch(e) {}
  };

  const confirmSaveProfile = () => {
    confirmDialog({
      message: '你確定要儲存並覆寫原有檔案內容嗎？',
      header: '確定儲存並覆寫',
      icon: 'pi pi-info-circle',
      defaultFocus: 'reject',
      acceptClassName: 'p-button-info',
      accept: () => saveProfile(),
    });
  };

  const saveProfile = async () => {
    setIsSaving(true);
    const responseUpdate = await fetchApi('user/updateHelperProfile', profile);
    if (responseUpdate.state === 1) {
      toast.current.show({ severity: 'success', summary: '編輯外傭資料', detail: '外傭資料已儲存成功' });
    } else {
      var errorItems = [];
      if (responseUpdate.error.includes('date_of_birth')) errorItems.push(<li>必須輸入出生日期或格式不正確</li>);
      if (responseUpdate.error.includes('about_me')) errorItems.push(<li>必須輸入自我介紹</li>);
      if (responseUpdate.error.includes('marital_id')) errorItems.push(<li>必須選取婚姻狀態</li>);
      if (responseUpdate.error.includes('nationality_id')) errorItems.push(<li>必須選取國籍</li>);
      if (responseUpdate.error.includes('place_id')) errorItems.push(<li>必須選取居住地</li>);
      if (responseUpdate.error.includes('education_id')) errorItems.push(<li>必須選取教育程度</li>);
      if (responseUpdate.error.includes('mobile')) errorItems.push(<li>必須輸入聯絡電話</li>);
      if (responseUpdate.error.includes('work_experience')) errorItems.push(<li>必須輸入年資</li>);
      if (responseUpdate.error.includes('work_type_id')) errorItems.push(<li>必須選取工作種類</li>);
      if (responseUpdate.error.includes('contract_status_id')) errorItems.push(<li>必須選取目前合約狀態</li>);
      if (responseUpdate.error.includes('available_date')) errorItems.push(<li>必須輸入可上工日期</li>);
      if (responseUpdate.error.includes('preferred_dayoff')) errorItems.push(<li>必須選取假期偏好</li>);
      if (responseUpdate.error.includes('preferred_work_location')) errorItems.push(<li>必須選取期望工作地點</li>);
      if (responseUpdate.error.includes('preferred_living')) errorItems.push(<li>必須選取住宿偏好</li>);
      if (responseUpdate.error.includes('skill')) errorItems.push(<li>必須選取技能</li>);
      if (responseUpdate.error.includes('cooking_skill')) errorItems.push(<li>必須選取烹飪技能</li>);
      if (responseUpdate.error.includes('language_proficiency')) errorItems.push(<li>必須選取語言技能</li>);
      if (responseUpdate.error.includes('personality')) errorItems.push(<li>必須選取個性</li>);
      if (responseUpdate.error.includes('job_type_id')) errorItems.push(<li>必須選取職位種類</li>);
      if (responseUpdate.error.includes('first_name')) errorItems.push(<li>必須輸入名字</li>);
      if (responseUpdate.error.includes('last_name')) errorItems.push(<li>必須輸入姓氏</li>);
      if (responseUpdate.error.includes('education_profiles')) errorItems.push(<li>學歷記錄內容不正確或有遺漏</li>);
      if (responseUpdate.error.includes('work_experience_profiles')) errorItems.push(<li>工作經驗記錄內容不正確或有遺漏</li>);
      toast.current.show({ severity: 'error', summary: '編輯外傭資料', detail:<><>儲存失敗：</><ul className="pl-4 mt-1">{errorItems}</ul></> });
    }
    setIsSaving(false);
  };

  const insertEducationProfile = () => {
    updateProfile('helper_profile_education_profiles', [
      ...profile.helper_profile_education_profiles,
      {
        id: crypto.randomUUID(),
        helper_profile_id: profile.id,
        education_id: 0,
        course_duration_id: 0,
        completion_year: '',
        completed: 0
      }
    ]);
  };
  const updateEducationProfiles = (id, updated_education_profile) => {
    const updatedEducationProfiles = profile.helper_profile_education_profiles.map((education_profile) => {
      if (education_profile.id === id) {
        return updated_education_profile;
      } else {
        return education_profile;
      }
    })
    updateProfile('helper_profile_education_profiles', updatedEducationProfiles);
  };
  const deleteEducationProfile = (id) => {
    const updatedEducationProfiles = profile.helper_profile_education_profiles.filter(education_profile => education_profile.id !== id);
    updateProfile('helper_profile_education_profiles', updatedEducationProfiles);
  };

  const insertWorkExperienceProfile = () => {
    updateProfile('helper_profile_work_experience_profiles', [
      ...profile.helper_profile_work_experience_profiles,
      {
        id: crypto.randomUUID(),
        helper_profile_id: profile.id,
        job_position_id: 0,
        work_nationality_id: 0,
        job_start_date: '',
        job_end_date: '',
        employer_type_id: 0,
        responsibility: '[]',
        reference_letter: 0,
      }
    ]);
  };
  const updateWorkExperienceProfiles = (id, updated_work_experience_profile) => {
    const updatedWorkExperienceProfiles = profile.helper_profile_work_experience_profiles.map((work_experience_profile) => {
      if (work_experience_profile.id === id) {
        return updated_work_experience_profile;
      } else {
        return work_experience_profile;
      }
    })
    updateProfile('helper_profile_work_experience_profiles', updatedWorkExperienceProfiles);
  };
  const deleteWorkExperienceProfile = (id) => {
    const updatedWorkExperienceProfiles = profile.helper_profile_work_experience_profiles.filter(work_experience_profile => work_experience_profile.id !== id);
    updateProfile('helper_profile_work_experience_profiles', updatedWorkExperienceProfiles);
  };

  return (
    <>
      <div className="text-3xl font-medium">外傭檔案編輯工具</div>
      <div className="flex justify-content-center mt-4 mb-6">
        <Message severity="warn" text="注意：編輯外傭檔案將完全覆寫原有檔案資料並無法還原，請小心使用此工具！" />
      </div>
      {profile === null ?
        <div className="flex justify-content-center m-6">
           <ProgressSpinner strokeWidth="3" style={{width: '32px', height: '32px'}} />
         </div>
      :
        <>
          <div className="grid">
            <div className="col-12 lg:col-2 flex flex-column gap-2"></div>
            <div className="col-12 lg:col-8 flex flex-column gap-2">
              <TabView>
                <TabPanel header="用戶資料">
                  <div className="grid w-full row-gap-3">
                    <div className="col-12 lg:col-3 flex flex-column gap-2">
                      <label className="font-semibold">User ID</label>
                      <InputText value={detail.id} disabled />
                    </div>
                    <div className="col-12 lg:col-3 flex flex-column gap-2">
                      <label className="font-semibold">First Name</label>
                      <InputText value={detail.first_name} disabled />
                    </div>
                    <div className="col-12 lg:col-3 flex flex-column gap-2">
                      <label className="font-semibold">Last Name</label>
                      <InputText value={detail.last_name} disabled />
                    </div>
                    <div className="col-12 lg:col-3 flex flex-column gap-2">
                      <label className="font-semibold">Helper Profile ID</label>
                      <InputText value={profile.id} disabled />
                    </div>
                  </div>
                </TabPanel>
                <TabPanel header="外傭資料">
                  <div className="grid w-full row-gap-3">
                    <div className="col-12 lg:col-3 flex flex-column gap-2">
                      <label className="font-semibold">名字 <Asterisk /></label>
                      <InputText value={profile.first_name} onChange={(e) => {updateProfile('first_name', e.target.value)}} />
                    </div>
                    <div className="col-12 lg:col-3 flex flex-column gap-2">
                      <label className="font-semibold">姓氏 <Asterisk /></label>
                      <InputText value={profile.last_name} onChange={(e) => {updateProfile('last_name', e.target.value)}} />
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">性別</label>
                      <div className="flex flex-wrap gap-3 mt-2">
                        <div className="flex align-items-center">
                            <RadioButton inputId="gender-1" name="gender" onChange={(e) => updateProfile('gender', 1)} checked={profile.gender === 1} />
                            <label htmlFor="gender-1" className="ml-2">女</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton inputId="gender-2" name="gender" onChange={(e) => updateProfile('gender', 2)} checked={profile.gender === 2} />
                            <label htmlFor="gender-2" className="ml-2">男</label>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">出生日期 <Asterisk /></label>
                      <Calendar value={new Date(profile.date_of_birth)} onChange={(e) => {updateProfile('date_of_birth', moment(e.target.value).format('YYYY-MM-DD'))}} dateFormat="yy-mm-dd" />
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">婚姻狀態 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={MARITALS.zh.filter(item => item.id===profile.marital_id)[0]} onChange={(e) => updateProfile('marital_id', e.value.id)} options={MARITALS.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">小孩</label>
                      <InputNumber value={profile.childs} onChange={(e) => {updateProfile('childs', e.value)}} useGrouping={false} inputClassName="w-full" />
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">國籍 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={NATIONALITIES.zh.filter(item => item.id===profile.nationality_id)[0]} onChange={(e) => updateProfile('nationality_id', e.value.id)} options={NATIONALITIES.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">居住地 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={NATIONALITIES.zh.filter(item => item.id===profile.place_id)[0]} onChange={(e) => updateProfile('place_id', e.value.id)} options={NATIONALITIES.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">生肖</label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={CHINESE_ZODIACS.zh.filter(item => parseInt(item.id)===profile.chinese_zodiac_id)[0]} onChange={(e) => updateProfile('chinese_zodiac_id', parseInt(e.value.id))} options={CHINESE_ZODIACS.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">宗教</label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={RELIGIONS.zh.filter(item => parseInt(item.id)===profile.religion_id)[0]} onChange={(e) => updateProfile('religion_id', parseInt(e.value.id))} options={RELIGIONS.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">持有有效護照</label>
                      <div className="flex flex-wrap gap-3 mt-2">
                        <div className="flex align-items-center">
                            <RadioButton inputId="valid_passport-1" name="valid_passport" onChange={(e) => updateProfile('valid_passport', 1)} checked={profile.valid_passport} />
                            <label htmlFor="valid_passport-1" className="ml-2">有</label>
                        </div>
                        <div className="flex align-items-center">
                            <RadioButton inputId="valid_passport-0" name="valid_passport" onChange={(e) => updateProfile('valid_passport', 0)} checked={!profile.valid_passport} />
                            <label htmlFor="valid_passport-0" className="ml-2">無</label>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">聯絡電話 <Asterisk /></label>
                      <InputText value={profile.mobile} onChange={(e) => {updateProfile('mobile', e.target.value)}} />
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">WhatsApp</label>
                      <InputText value={profile.whatsapp} onChange={(e) => {updateProfile('whatsapp', e.target.value)}} />
                    </div>
                    {/* <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">Year of Birth</label>
                      <InputNumber value={profile.year_of_birth} onChange={(e) => {updateProfile('year_of_birth', e.value)}} useGrouping={false} />
                    </div> */}
                  </div>
                </TabPanel>
                <TabPanel header="資歷相關">
                  <div className="grid w-full col-gap-3">
                    <div className="col-12 lg:col-7 flex flex-row gap-2">
                      <div className="grid w-full row-gap-3">
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <div className="flex justify-content-between">
                            <label className="font-semibold">自我介紹 <Asterisk /></label>
                          </div>
                          <InputTextarea value={profile.about_me} onChange={(e) => {updateProfile('about_me', e.target.value)}} rows={3} autoResize />
                        </div>
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <label className="font-semibold">自我介紹影片 (YouTube)</label>
                          <InputText value={profile.self_introduction_youtube} onChange={(e) => {updateProfile('self_introduction_youtube', e.target.value)}} />
                        </div>
                        <div className="col-12 lg:col-6 flex flex-column gap-2">
                          <label className="font-semibold">教育程度 <Asterisk /></label>
                          <div className="flex flex-wrap gap-3">
                            <Dropdown value={EDUCATIONS.zh.filter(item => parseInt(item.id)===profile.education_id)[0]} onChange={(e) => updateProfile('education_id', parseInt(e.value.id))} options={EDUCATIONS.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                          </div>
                        </div>
                        <div className="col-12 lg:col-6 flex flex-column gap-2">
                          <label className="font-semibold">年資</label>
                          <InputNumber value={profile.work_experience} onChange={(e) => {updateProfile('work_experience', e.value)}} useGrouping={false} />
                        </div>
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <label className="font-semibold">技能</label>
                          <div className="flex flex-wrap gap-3 mt-2">
                            {SKILLS.zh.map((item, index) => {
                              return (
                                <div className="flex align-items-center" key={index}>
                                  <Checkbox inputId={`skill_id-${item.id}`} name="skill_id" onChange={(e) => updateProfileCheckbox('skill', e.checked, parseInt(item.id))} checked={profile.skill.includes(parseInt(item.id))} />
                                  <label htmlFor={`skill_id-${item.id}`} className="ml-2">{item.name}</label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <label className="font-semibold">烹飪技能</label>
                          <div className="flex flex-wrap gap-3 mt-2">
                            {COOKING_SKILLS.zh.map((item, index) => {
                              return (
                                <div className="flex align-items-center" key={index}>
                                  <Checkbox inputId={`cooking_skill_id-${item.id}`} name="cooking_skill_id" onChange={(e) => updateProfileCheckbox('cooking_skill', e.checked, parseInt(item.id))} checked={profile.cooking_skill.includes(parseInt(item.id))} />
                                  <label htmlFor={`cooking_skill_id-${item.id}`} className="ml-2">{item.name}</label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <label className="font-semibold">語言技能 <Asterisk /></label>
                          <div className="flex flex-wrap gap-3 mt-2">
                            {LANGUAGES.zh.map((item, index) => {
                              return (
                                <div className="flex align-items-center" key={index}>
                                  <Checkbox inputId={`language_id-${item.id}`} name="language_id" onChange={(e) => updateProfileCheckbox('language_proficiency', e.checked, parseInt(item.id))} checked={profile.language_proficiency.includes(parseInt(item.id))} />
                                  <label htmlFor={`language_id-${item.id}`} className="ml-2">{item.name}</label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <div className="flex justify-content-between">
                            <label className="font-semibold">其他技能</label>
                          </div>
                          <InputTextarea value={profile.skill_remark} onChange={(e) => {updateProfile('skill_remark', e.target.value)}} rows={3} autoResize />
                        </div>
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <label className="font-semibold">個性 <Asterisk /></label>
                          <div className="flex flex-wrap gap-3 mt-2">
                            {PERSONALITIES.zh.map((item, index) => {
                              return (
                                <div className="flex align-items-center" key={index}>
                                  <Checkbox inputId={`personality_id-${item.id}`} name="personality_id" onChange={(e) => updateProfileCheckbox('personality', e.checked, parseInt(item.id))} checked={profile.personality.includes(parseInt(item.id))} />
                                  <label htmlFor={`personality_id-${item.id}`} className="ml-2">{item.name}</label>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <div className="flex justify-content-between">
                            <label className="font-semibold">其他工作經驗</label>
                          </div>
                          <InputTextarea value={profile.work_experience_remark} onChange={(e) => {updateProfile('work_experience_remark', e.target.value)}} rows={3} autoResize />
                        </div>
                        
                        <div className="col-12 lg:col-12 flex flex-column gap-2">
                          <div className="flex justify-content-between">
                            <label className="font-semibold">其他學歷</label>
                          </div>
                          <InputTextarea value={profile.education_remark} onChange={(e) => {updateProfile('education_remark', e.target.value)}} rows={3} autoResize />
                        </div>

                      </div>
                    </div>
                    <div className="col-12 lg:col-5 flex flex-column gap-2">
                      <Fieldset legend="學歷">
                        {profile.helper_profile_education_profiles.length === 0 ?
                          <div className="text-center">未有學歷記錄</div>
                        :
                          profile.helper_profile_education_profiles.map((education_profile) => {
                            return <EducationProfileBoxEdit key={education_profile.id} profile={education_profile} onChange={(id, profile) => {updateEducationProfiles(id, profile)}} onDelete={() => {deleteEducationProfile(education_profile.id)}} />
                          })
                        }
                        <div className="mt-3 flex justify-content-center">
                          <Button label="新增學歷" onClick={insertEducationProfile} icon="pi pi-plus" size="small" className="px-2 py-1" outlined />
                        </div>
                      </Fieldset>
                      <Fieldset legend="工作經驗">
                        {profile.helper_profile_work_experience_profiles.length === 0 ?
                          <div className="text-center">未有工作經驗記錄</div>
                        :
                          profile.helper_profile_work_experience_profiles.map((work_experience_profile) => {
                            return <WorkExperienceProfileBoxEdit key={work_experience_profile.id} profile={work_experience_profile} onChange={(id, profile) => {updateWorkExperienceProfiles(id, profile)}} onDelete={() => {deleteWorkExperienceProfile(work_experience_profile.id)}} />
                          })
                        }
                        <div className="mt-3 flex justify-content-center">
                          <Button label="新增工作經驗" onClick={insertWorkExperienceProfile} icon="pi pi-plus" size="small" className="px-2 py-1" outlined />
                        </div>
                      </Fieldset>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel header="申請職位詳情">
                  <div className="grid w-full row-gap-3">
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">職位種類 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={JOB_TYPES.zh.filter(item => parseInt(item.id)===profile.job_type_id)[0]} onChange={(e) => updateProfile('job_type_id', parseInt(e.value.id))} options={JOB_TYPES.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">工作種類 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={WORK_TYPES.zh.filter(item => parseInt(item.id)===profile.work_type_id)[0]} onChange={(e) => updateProfile('work_type_id', parseInt(e.value.id))} options={WORK_TYPES.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">目前合約狀態 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={CONTRACT_STATUSES.zh.filter(item => parseInt(item.id)===profile.contract_status_id)[0]} onChange={(e) => updateProfile('contract_status_id', parseInt(e.value.id))} options={CONTRACT_STATUSES.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">可上工日期 <Asterisk /></label>
                      <Calendar value={new Date(profile.available_date)} onChange={(e) => {updateProfile('available_date', moment(e.target.value).format('YYYY-MM-DD'))}} dateFormat="yy-mm-dd" />
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">期望薪酬</label>
                      <InputNumber value={profile.expected_salary} onChange={(e) => {updateProfile('expected_salary', e.value)}} useGrouping={false} inputClassName="w-full" />
                    </div>
                    <div className="col-12 lg:col-2 flex flex-column gap-2">
                      <label className="font-semibold">貨幣</label>
                      <div className="flex flex-wrap gap-3">
                        <Dropdown value={CURRENCIES.zh.filter(item => item.id===profile.currency_id)[0]} onChange={(e) => updateProfile('currency_id', e.value.id)} options={CURRENCIES.zh} optionLabel="name" placeholder="選擇" className="w-full" />
                      </div>
                    </div>
                    <div className="col-12 lg:col-12 flex flex-column gap-2">
                      <label className="font-semibold">期望工作地點 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3 mt-2">
                        {WORK_LOCATIONS.zh.map((item, index) => {
                          return (
                            <div className="flex align-items-center" key={index}>
                              <Checkbox inputId={`work_location_id-${item.id}`} name="work_location_id" onChange={(e) => updateProfileCheckbox('preferred_work_location', e.checked, parseInt(item.id))} checked={profile.preferred_work_location.includes(parseInt(item.id))} />
                              <label htmlFor={`work_location_id-${item.id}`} className="ml-2">{item.name}</label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="col-12 lg:col-12 flex flex-column gap-2">
                      <label className="font-semibold">假期偏好 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3 mt-2">
                        {DAYOFFS.zh.map((item, index) => {
                          return (
                            <div className="flex align-items-center" key={index}>
                              <Checkbox inputId={`dayoff_id-${item.id}`} name="dayoff_id" onChange={(e) => updateProfileCheckbox('preferred_dayoff', e.checked, parseInt(item.id))} checked={profile.preferred_dayoff.includes(parseInt(item.id))} />
                              <label htmlFor={`dayoff_id-${item.id}`} className="ml-2">{item.name}</label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="col-12 lg:col-12 flex flex-column gap-2">
                      <label className="font-semibold">住宿偏好 <Asterisk /></label>
                      <div className="flex flex-wrap gap-3 mt-2">
                        {LIVINGS.zh.map((item, index) => {
                          return (
                            <div className="flex align-items-center" key={index}>
                              <Checkbox inputId={`living_id-${item.id}`} name="living_id" onChange={(e) => updateProfileCheckbox('preferred_living', e.checked, parseInt(item.id))} checked={profile.preferred_living.includes(parseInt(item.id))} />
                              <label htmlFor={`living_id-${item.id}`} className="ml-2">{item.name}</label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </TabPanel>
              </TabView>
              <div className="grid w-full row-gap-3">
                {/* <div className="col-12 lg:col-12 flex flex-column gap-2">
                  <Button link label="填入隨機資料" onClick={getRandomData} />
                </div> */}
                <div className="col-12 lg:col-12 flex flex-column gap-2 mt-4">
                  <Button label={isSaving?'儲存中⋯':'更新外傭檔案'} disabled={isSaving} onClick={confirmSaveProfile} />
                </div>
              </div>
            </div>
            <div className="col-12 lg:col-2 flex flex-column gap-2"></div>
            <div className="col-12 lg:col-12" style={{ paddingBottom: 200 }}></div>
            <ConfirmDialog />
            <Toast ref={toast} position="bottom-center" />
          </div>
        </>
      }
    </>
  );
};
  
export default HelperUpdate;
